import { format } from "date-fns-tz"

export class CardModel {
    constructor (data) {
        this.cardNumber = data.cardNumber
        this.expiredDate = data.expiredDate
        this.cardHash = data.cardHash
        this.userId = data.userId
        this.cardId = data.cardId
        this.updateDate = this._updateDate(data.updateDate)
    }

    _updateDate (updateDate) {
        const date = new Date(updateDate)
        return format(date, "dd.MM.yyyy HH:mm:ss")
    }

    toCsv (delimiter) {
        const delim = delimiter || ';'
        return this.cardNumber + delim +
            this.expiredDate + delim +
            this.cardHash + delim +
            this.userId + delim +
            this.cardId + delim +
            this.updateDate + delim + '\n'
    }
}

export const CardTitlesModel = [
    {
        text: "Участник",
        value: "userId",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Номер карты",
        value: "cardNumber",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Срок обслуживания",
        value: "expiredDate",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Хэш карты",
        value: "cardHash",
        filterType: "text",
        filterValues: []
    },
    {
        text: "Последняя дата изменения",
        value: "updateDate",
        filterType: "date",
        filterValues: []
    }
]

export const CardHeadersModel = CardTitlesModel.map(m =>
    Object.fromEntries(
        Object.entries(m)
            .filter(([key]) => ['text', 'value'].includes(key))
    )
)
